
import isNil from 'lodash/isNil';

export default function showPositionOnTrajectory(viewer, trjName, photoName, x, y, z, yaw, pitch, options) {
    if (viewer) {
        options = options || {};
        MultiSceneCore.Api.showPositionOnTrajectory(
            viewer, trjName, photoName, x, y, z, yaw || 0, pitch || 0,
            options
        );
        let scene = viewer.getActualDimensionScene();
        if (scene) {
            if (!isNil(options.pointCloudFreeze)) {
                scene.setPotreeFreeze(options.pointCloudFreeze);
            }
        }
    }
}
